<template>
  <div class="e-flex jc-between bar-form">
    <span class="fs-md fw-6">
      <template v-if="text">
        <div>
          {{ text }}
        </div>
      </template>
      <span class="breadcrumb">
        <slot></slot>
      </span>
    </span>
    <span>带<span class="text-red">*</span>必填</span>
  </div>
</template>
<script>
export default {
  props: {
    text: String,
  },
}
</script>
<style scoped lang="less">
.bar-form {
  margin: 20px 0;
  text-align: center;
  padding: 15px 25px;
  overflow: hidden;
  color: #333333;
  background: #edf5fa;
  .text-red {
    display: inline-block;
    margin: 0 6px;
  }
  .breadcrumb {
    /deep/ .el-breadcrumb__inner {
      font-weight: 800;
    }
    /deep/ .el-breadcrumb {
      font-size: 1.6rem;
      line-height: inherit;
    }
  }
}
</style>
